import { render, staticRenderFns } from "./m-safety-dialog.vue?vue&type=template&id=b6dcde14&scoped=true&"
import script from "./m-safety-dialog.vue?vue&type=script&lang=js&"
export * from "./m-safety-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-safety-dialog.vue?vue&type=style&index=0&id=b6dcde14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dcde14",
  null
  
)

export default component.exports